<template>
  <Icon
    name="event"
    :width="16"
    :height="20"
  >
    <path d="M14 13.75V8.75C14 5.67999 12.37 3.10999 9.5 2.42999V1.75C9.5 0.920013 8.82996 0.25 8 0.25C7.17004 0.25 6.5 0.920013 6.5 1.75V2.42999C3.64001 3.10999 2 5.67001 2 8.75V13.75L0 15.75V16.75H16V15.75L14 13.75ZM8 19.75C9.09998 19.75 10 18.85 10 17.75H6C6 18.85 6.90002 19.75 8 19.75ZM4 14.75H12V8.75C12 6.26999 10.49 4.25 8 4.25C5.51001 4.25 4 6.26999 4 8.75V14.75Z" />
  </Icon>
</template>

<script>
import Icon from "../Elements/Icon";

export default {
  name: 'Event',
  components: { Icon },
};
</script>
